import { useEnvelopeTemplatesQuery } from './EnvelopeTemplates.graphql.generated';

export const useEnvelopeTemplates = () => {
  const { data, loading, error } = useEnvelopeTemplatesQuery({ batchMode: 'fast' });
  return { templates: data?.stationeryEnvelopeTemplates ?? [], loading, error };
};
